module.exports = __webpack_public_path__ + "static/img/IMG_20240326_143429.9bd648f9.jpg";